import { Tag } from "@/themes/ci/blog/types";
import Badge from "./Badge";

const Badges = ({ badges, limit }: { badges: Tag[]; limit: number }) => {
  const renderedBadges = badges
    .slice(0, limit)
    .map((tag) => (
      <Badge key={tag.slug} link={`/blog/1?tags=${tag.slug}`} name={tag.name} />
    ));

  return <div>{renderedBadges}</div>;
};

export default Badges;
